
import React, {
    useState
    // , useEffect
} from 'react'
import {
    List, Footer, Swiper, Ellipsis,Image,
    // Tag,
    Empty,
    Modal, Dialog, NumberKeyboard, PasscodeInput, Tabs, AutoCenter, Space, NoticeBar, Grid
} from 'antd-mobile'
// import { Image } from 'antd';
import { ExclamationCircleFill, CheckCircleFill, CheckCircleOutline } from 'antd-mobile-icons'
import { useSearchParams } from 'react-router-dom'
import { request } from "@/utils";
import "./index.scss";
import { createFromIconfontCN } from '@ant-design/icons';
const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_5071536_eflru295vmb.js', // 在 iconfont.cn 上生成
});

const Ylso2 = () => {
    const [urlp] = useSearchParams()
    const [visible, setVisible] = useState(urlp.get('dw') === 'yz' ? true : false)
    const [menus, setMenu] = useState("m11");
    const token = JSON.parse(localStorage.getItem('cx315_token'))
    // const about = token.about
    // const cpxq = token.json.cpxq
    const cpsm = token.json.cpsm

    const imgjsonz = token.pjson1.imgjson
    const mjson = token.pjson1.mjson
    const ycm1 = token.json.ycm1
    const ycm2 = token.json.ycm2
    const ycm3 = token.json.ycm3
    const ycm4 = token.json.ycm4

    const ycm5 = token.json.ycm5
    const ycm6 = token.json.ycm6
    const ycm7 = token.json.ycm7
    const ycm8 = token.json.ycm8
    const ycm9 = token.json.ycm9

    console.log("五=" + Array.isArray(token.json.ycm5[0]))








    const imgjson = imgjsonz !== undefined ? imgjsonz.map((e) => (
        <Swiper.Item key={e.uid}>
            <Image src={e.url} preview={false} />
        </Swiper.Item>
    )) : [];

    const onFill = async (value) => {

        const opno = { opno: urlp.get('code') };
        const ycode = { yzcode: value };
        const values = token.resq
        const val_e = Object.assign(values, ycode, opno);


        const res = await request.post('/p_qrcode_yz', val_e)
        setVisible(false)

        Dialog.alert({
            header: (res.return_code === 'success' ? <CheckCircleFill
                style={{
                    fontSize: 46,
                    color: '#389e0d',
                }}
            /> : <ExclamationCircleFill
                style={{
                    fontSize: 46,
                    color: 'var(--adm-color-warning)',
                }}
            />
            ),
            title: res.return_msg,
            content: res.return_body,
            confirmText: '关闭',

        })



    }



    return <>
        {/* 追溯默认页面，显示基本信息，若有活动=》渲染，若有找回信息=》渲染, */}
        {imgjsonz !== undefined && <Swiper loop
            autoplay>
            {imgjson}
        </Swiper>}
        <AutoCenter style={{ marginTop: "30px", marginBottom: "30px" }}>


            <span style={{ fontSize: "28px", fontWeight: "bolder", color: `${token.pjson1.mcv}` }}>{token.json.pname} </span>
            {/* < Divider style={{
                color: `${token.pjson1.mcv}`,
                borderColor: `${token.pjson1.mcv}`,
                borderStyle: "solid",
                width: "180px",
                alignItems: "center"
            }}>●</Divider> */}

        </AutoCenter>


        <List style={{ '--font-size': '1em' }} key='JB01'>
            <List.Item extra={token.resq.dbcode} key='JB011'> 单元识别码</List.Item>
            <List.Item extra={token.resq.dbno} key='JB012'>数据批次</List.Item>
            {/* <List.Item extra={token.resq.dbtype === 'S' ? "最小销售单元" : "集合外包"} key='JB013'>数据类型</List.Item> */}

            <List.Item description={<Ellipsis
                direction='end'
                content={`http://cx315.com/${token.resq.dbno}/${token.resq.dbtype}/${token.resq.dbcode}`}
                expandText='展开'
                collapseText='收起'
            />} key='JB014'>
                追溯网址
            </List.Item>
            {/* <List.Item extra={<Tag
                color='success'
                fill='outline'
                style={{ '--border-color': `${token.pjson1.mcv}`, '--border-radius': '3px', '--font-size': '26px' }}
            >
                {token.e_json.s_num}
            </Tag>} key='JB015' > 扫描次数</List.Item> */}

            <List.Item extra={token.db_json.gjson[0].ggn} key='JB013'>{token.db_json.gjson[0].ggm}</List.Item>


            {mjson.map((m, i) => (
                m.list.map((k, index) => (

                    <List.Item
                        extra={<Ellipsis
                            direction='end'
                            content={k.second}
                            expandText='展开'
                            collapseText='收起'
                        />}

                        key={`JBT${i}AA${index}`}
                    >
                        {k.first}
                    </List.Item>

                ))

            )
            )
            }

        </List>

        {/*  */}

        <Grid columns={5} gap={8} className='gtclass' style={{ "--gap-vertical": "28px" }}>
            <Grid.Item>
                <Space direction='vertical' align="center" className='spacem1'
                    onClick={() => {
                        setMenu("m1")
                    }}
                >
                    <MyIcon type="icon-jidi1" className='yiconclass spacem1' />
                    <span>基地信息</span>
                </Space>

            </Grid.Item>
            <Grid.Item>
                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m2") }}
                >
                    <MyIcon type="icon-zhongzi" className='yiconclass' />
                    <span>种源信息</span>
                </Space>

            </Grid.Item>
            <Grid.Item>
                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m3") }}
                >
                    <MyIcon type="icon-plant" className='yiconclass' />
                    <span>种植信息</span>
                </Space>
            </Grid.Item>
            <Grid.Item>

                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m4") }}
                >
                    <MyIcon type="icon-shebeitubiao-18" className='yiconclass' />
                    <span>农事记录</span>
                </Space>

            </Grid.Item>
            <Grid.Item>

                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m5") }}
                >
                    <MyIcon type="icon-zhongzhishifeijixie" className='yiconclass' />
                    <span>采收信息</span>
                </Space>


            </Grid.Item>
            <Grid.Item>

                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m6") }}
                >
                    <MyIcon type="icon-app_scjd" className='yiconclass' />
                    <span>加工信息</span>
                </Space>


            </Grid.Item>
            <Grid.Item>

                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m7") }}
                >
                    <MyIcon type="icon-wuliaobaozhuangdan" className='yiconclass' />
                    <span>包装信息</span>
                </Space>


            </Grid.Item>
            <Grid.Item>
                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m8") }}
                >
                    <MyIcon type="icon-cangku1" className='yiconclass' />
                    <span>仓储信息</span>
                </Space>

            </Grid.Item>
            <Grid.Item>

                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m9") }}
                >
                    <MyIcon type="icon-lailiaopinzhijianyan" className='yiconclass' />
                    <span>质检信息</span>
                </Space>

            </Grid.Item>


            {/* <Grid.Item>
          <Space direction='vertical' align="center">
          <MyIcon type="icon-chanpinjieshao"  className='yiconclass'/>
          <span>产品介绍</span>
          </Space>
          </Grid.Item> */}

            <Grid.Item>

                <Space direction='vertical' align="center"
                    onClick={() => { setMenu("m10") }}
                >
                    <MyIcon type="icon-qiye1" className='yiconclass' />
                    <span>企业介绍</span>
                </Space>

            </Grid.Item>

            {/* <Grid.Item>
          <Space direction='vertical' align="center">
          <MyIcon type="icon-daohang1"  className='yiconclass'/>
          <span>基地地图</span>
          </Space>
          </Grid.Item> */}


        </Grid>

        <Modal
            visible={visible}
            title={<Space direction='vertical'>
                {(token.e_json.y_num >= 1 && token.show_cqz) && <NoticeBar icon={<ExclamationCircleFill style={{ color: 'var(--adm-color-warning)', }} />} content='已被验证，请严防假冒！' color='alert' />}
                <AutoCenter style={{ '--text-color': '#595959', fontSize: '16px', }}>请输入验证码</AutoCenter>
            </Space>
            }
            content={<PasscodeInput length={6} plain onFill={onFill} keyboard={<NumberKeyboard title='数字键盘' />} defaultValue='' />}
            closeOnAction
            closeOnMaskClick={true}
            onClose={() => { setVisible(false) }}
        />

        <Tabs defaultActiveKey='m11'
            activeKey={menus}
        >



            {/* 基地信息 */}
            <Tabs.Tab key='m1'>
                <div style={{
                    position: 'relative',
                }}>
                    {!ycm1 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无种源信息'
                    />
                    }

                    {ycm1 && ycm1.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${ni2}`}
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>

                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))


                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${i2}`}
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>




                        // 三目f end 












                        // 
                    )
                    )
                    }


                </div>


            </Tabs.Tab>
            {/* 种源信息 */}
            <Tabs.Tab key='m2'>

                {!ycm2 && <Empty
                    style={{ padding: '64px 0' }}
                    imageStyle={{ width: 128 }}
                    description='暂无种源信息'
                />
                }

                {ycm2 && ycm2.map((m2, i2) => (

                    Array.isArray(m2) ? m2.map((nm2, ni2) => (

                        <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                            {nm2.mname && <div style={{
                                width: '100%',
                                height: '39px',
                                background: '#02af6f',
                                backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                color: '#FFF',
                                lineHeight: '39px',
                                paddingLeft: '10px',

                            }}
                                key={`JBTsm2${ni2}`}
                            >

                                {nm2.mname}
                            </div>}


                            {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                return <>
                                    <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                    </List.Item>


                                </>

                            })}

                            {nm2.list.map((km2, m2index) => (

                                <List.Item
                                    extra={<Ellipsis
                                        direction='end'
                                        content={km2.second}
                                        expandText='展开'
                                        collapseText='收起'
                                    />}

                                    key={`JBTm2${i2}AA${m2index}`}
                                >
                                    {km2.first}
                                </List.Item>

                            ))}






                        </List>
                    ))


                        : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                            {m2.mname && <div style={{
                                width: '100%',
                                height: '39px',
                                background: '#02af6f',
                                backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                color: '#FFF',
                                lineHeight: '39px',
                                paddingLeft: '10px',

                            }}
                                key={`JBTsm2${i2}`}
                            >

                                {m2.mname}
                            </div>}


                            {m2.upload && m2.upload.map((upm2, iim2) => {
                                return <>
                                    <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                    </List.Item>


                                </>


                            })}

                            {m2.list.map((km2, m2index) => (

                                <List.Item
                                    extra={<Ellipsis
                                        direction='end'
                                        content={km2.second}
                                        expandText='展开'
                                        collapseText='收起'
                                    />}

                                    key={`JBTm2${i2}AA${m2index}`}
                                >
                                    {km2.first}
                                </List.Item>

                            ))}






                        </List>




                    // 三目f end 












                    // 
                )
                )
                }



            </Tabs.Tab>
            {/* 种植信息 */}
            <Tabs.Tab key='m3'>
                <div className='nsjl'>

                    {!ycm3 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无种源信息'
                    />
                    }
                    {ycm3 && ycm3.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${ni2}`}
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>

                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))


                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${i2}`}
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>




                        // 三目f end 












                        // 
                    )
                    )
                    }


                </div>
            </Tabs.Tab>
            {/* 农事记录  时间轴 */}
            <Tabs.Tab key='m4'>

                {ycm4 && ycm4.map((m2, i2) => (

                    Array.isArray(m2) ? m2.map((nm2, ni2) => (

                        <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                            {nm2.mname && <div style={{
                                width: '100%',
                                height: '39px',
                                background: '#02af6f',
                                backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                color: '#FFF',
                                lineHeight: '39px',
                                paddingLeft: '10px',

                            }}
                                key={`JBTsm2${ni2}`}
                            >

                                {nm2.mname}
                            </div>}


                            {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                return <>
                                    <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                    </List.Item>


                                </>

                            })}

                            {nm2.list.map((km2, m2index) => (

                                <List.Item
                                    extra={<Ellipsis
                                        direction='end'
                                        content={km2.second}
                                        expandText='展开'
                                        collapseText='收起'
                                    />}

                                    key={`JBTm2${i2}AA${m2index}`}
                                >
                                    {km2.first}
                                </List.Item>

                            ))}






                        </List>
                    ))


                        : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                            {m2.mname && <div style={{
                                width: '100%',
                                height: '39px',
                                background: '#02af6f',
                                backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                color: '#FFF',
                                lineHeight: '39px',
                                paddingLeft: '10px',

                            }}
                                key={`JBTsm2${i2}`}
                            >

                                {m2.mname}
                            </div>}


                            {m2.upload && m2.upload.map((upm2, iim2) => {
                                return <>
                                    <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                        {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                    </List.Item>


                                </>


                            })}

                            {m2.list.map((km2, m2index) => (

                                <List.Item
                                    extra={<Ellipsis
                                        direction='end'
                                        content={km2.second}
                                        expandText='展开'
                                        collapseText='收起'
                                    />}

                                    key={`JBTm2${i2}AA${m2index}`}
                                >
                                    {km2.first}
                                </List.Item>

                            ))}






                        </List>




                    // 三目f end 












                    // 
                )
                )
                }





            </Tabs.Tab>


            {/* 采收信息 */}
            <Tabs.Tab key='m5'>
                <div className='about' >

                    {!ycm5 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无采收信息'
                    />
                    }

                    {ycm5 && ycm5.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${ni2}`}
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))









                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${i2}`}
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>












                        // 
                    )
                    )
                    }




                </div>
            </Tabs.Tab>


            {/* 加工信息 */}
            <Tabs.Tab key='m6'>
                <div className='about' >

                    {!ycm6 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无采收信息'
                    />
                    }

                    {ycm6 && ycm6.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${ni2}`}
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))









                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${i2}`}
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>












                        // 
                    )
                    )
                    }



                </div>
            </Tabs.Tab>
            {/* 包装信息 */}
            <Tabs.Tab key='m7'>
                <div className='about' >
                    {!ycm7 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无采收信息'
                    />
                    }

                    {ycm7 && ycm7.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${ni2}`}
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))









                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${i2}`}
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>












                        // 
                    )
                    )
                    }



                </div>
            </Tabs.Tab>



            {/* 仓储信息 */}
            <Tabs.Tab key='m8'>
                <div className='about'>

                    {!ycm8 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无采收信息'
                    />
                    }

                    {ycm8 && ycm8.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',


                                }}
                                    key={`JBTsm2${ni2}`}
                                    className='smtcss'
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))









                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',


                                }}
                                    key={`JBTsm2${i2}`}

                                    className='smtcss'
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>












                        // 
                    )
                    )
                    }



                </div>
            </Tabs.Tab>

            {/* 质检信息 */}
            <Tabs.Tab key='m9'>
                <div className='about' >

                    {!ycm9 && <Empty
                        style={{ padding: '64px 0' }}
                        imageStyle={{ width: 128 }}
                        description='暂无采收信息'
                    />
                    }

                    {ycm9 && ycm9.map((m2, i2) => (

                        Array.isArray(m2) ? m2.map((nm2, ni2) => (

                            <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {nm2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px'



                                }}
                                    key={`JBTsm2${ni2}`}
                                >

                                    {nm2.mname}
                                </div>}


                                {nm2.upload && nm2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {nm2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>
                        ))









                            : <List style={{ '--font-size': '1em' }} key={`JTm2${i2}`}>
                                {m2.mname && <div style={{
                                    width: '100%',
                                    height: '39px',
                                    background: '#02af6f',
                                    backgroundImage: `linear-gradient(to right, ${token.pjson1.mcv} , #fff)`,
                                    color: '#FFF',
                                    lineHeight: '39px',
                                    paddingLeft: '10px',

                                }}
                                    key={`JBTsm2${i2}`}
                                >

                                    {m2.mname}
                                </div>}


                                {m2.upload && m2.upload.map((upm2, iim2) => {
                                    return <>
                                        <List.Item key={`imgm2${i2}${iim2}`} className='rzlsit'>
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "image" && <Image src={upm2.url} preview={true} />}
                                            {upm2.type.substring(0, upm2.type.indexOf("/")) === "video" && <video muted width='100%' controls src={upm2.url} />}
                                        </List.Item>


                                    </>


                                })}

                                {m2.list.map((km2, m2index) => (

                                    <List.Item
                                        extra={<Ellipsis
                                            direction='end'
                                            content={km2.second}
                                            expandText='展开'
                                            collapseText='收起'
                                        />}

                                        key={`JBTm2${i2}AA${m2index}`}
                                    >
                                        {km2.first}
                                    </List.Item>

                                ))}






                            </List>












                        // 
                    )
                    )
                    }

                </div>
            </Tabs.Tab>


            {/* 企业介绍 */}
            <Tabs.Tab key='m10'>
                {decodeURIComponent(cpsm) === "undefined" ? <Empty
                    style={{ padding: '64px 0' }}
                    imageStyle={{ width: 128 }}
                    description='该单位没上传企业信息'
                /> : <div className='about' dangerouslySetInnerHTML={{ __html: decodeURIComponent(cpsm) }}></div>}
            </Tabs.Tab>


            <Tabs.Tab key='m11'>
                <div className='about' ></div>
            </Tabs.Tab>









        </Tabs>

        <Footer
            style={{ "--background-color": `${token.pjson1.mcv}` }}
            content={<Space direction='vertical' align="center">
                <Space style={{ color: "#FFFFFF", fontSize: "14px" }}>

                    <CheckCircleOutline />源头可溯
                    <CheckCircleOutline />去向可追
                    <CheckCircleOutline />责任可究
                    <CheckCircleOutline />公众可查


                </Space>
                <span style={{ color: "#FFFFFF" }}>@ 2024-2026 胜聪网 All rights reserved</span></Space>}
        ></Footer>





    </>
}

export default Ylso2;